<template>
  <div>
    <div class="data-entry-container-parent">
      <div
        class="data-entry-container"
        v-for="(buttonGroup, i) in buttonGroups"
        :key="i"
      >
        <data-entry-button
          v-for="(button, j) in buttonGroup"
          :key="j"
          :title="button.title"
          :onClick="button.onClick"
        ></data-entry-button>
      </div>
    </div>
    <div v-if="trapMaster || larvalMaster">
      <div class="associated-site-masters">
        <div>Associated Site Masters:</div>
        <div v-if="trapMaster" class="associated-site-masters clickable">
          <router-link
            :to="{
              name: 'data-trap-site-details',
              params: { id: mappable.trapSites[0].id },
            }"
          >
            Trap
          </router-link>
        </div>
        <span v-if="trapMaster && larvalMaster">|</span>
        <div v-if="larvalMaster" class="associated-site-masters clickable">
          <router-link
            :to="{
              name: 'data-larval-site-details',
              params: { id: mappable.larvalSites[0].id },
            }"
          >
            Larval
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataEntryButton from './data-entry-button';

export default {
  components: {
    DataEntryButton,
  },

  props: {
    mappable: Object,
  },

  computed: {
    trapMaster() {
      const { trapSites } = this.mappable;
      return trapSites && trapSites.length;
    },
    larvalMaster() {
      const { larvalSites } = this.mappable;
      return larvalSites && this.mappable.larvalSites.length;
    },
    buttonGroups() {
      const params = {
        type: 's',
        id: this.mappable.id,
      };

      if (this.mappable.mappableType === 'No Spray') {
        return [[{ title: 'Complete Spray Form', onClick: () => null }]];
      } else if (this.mappable.mappableType === 'Service Request') {
        return [
          [
            {
              title: 'Complete Service Request',
              onClick: () =>
                this.$router.push({
                  name: 'data-service-request-details',
                  params,
                }),
            },
          ],
        ];
      }

      const addTrapSite = {
        title: 'Trap Site',
        onClick: () =>
          this.$router.push({ name: 'data-trap-site-with', params }),
      };
      const adultSurveillance = {
        title: 'Adult Surv.',
        onClick: () =>
          this.$router.push({ name: 'data-adult-surveillances-with', params }),
      };

      const addLarvalSite = {
        title: 'Larval Site',
        onClick: () =>
          this.$router.push({ name: 'data-larval-site-with-s', params }),
      };
      const larvicide = {
        title: 'Larvicide',
        onClick: () =>
          this.$router.push({ name: 'data-larvicide-with', params }),
      };

      return [
        [
          this.trapMaster ? adultSurveillance : addTrapSite,
          this.larvalMaster ? larvicide : addLarvalSite,
        ],
        [
          {
            title: 'Adulticide',
            onClick: () =>
              this.$router.push({ name: 'data-adulticide-with', params }),
          },
          {
            title: 'Landing Rate',
            onClick: () =>
              this.$router.push({ name: 'data-landing-rates-new', params }),
          },
        ],
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.data-entry-container-parent {
  margin: -0.6rem;
}

.data-entry-container {
  display: flex;
  width: 100%;
}

.associated-site-masters {
  display: flex;
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  margin: 1rem 0 2rem;
  color: rgba(0, 0, 0, 0.87);

  & .associated-site-masters.clickable {
    font-weight: 500;
    color: $blue !important;
    margin: 0 0.5rem;
    text-transform: uppercase;
  }
}
</style>
